import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api, ApiError } from "../api/client";

export function ClaimOwner() {
  const qc = useQueryClient();
  const [code, setCode] = useState("");
  const [error, setError] = useState<string | null>(null);

  const claim = useMutation({
    mutationFn: async (claimCode: string) => {
      return api<{ redirect: string }>("/auth/claim-owner", {
        method: "POST",
        body: JSON.stringify({ code: claimCode }),
      });
    },
    onSuccess: (data) => {
      qc.invalidateQueries({ queryKey: ["auth", "me"] });
      const hashOnly = data.redirect.replace(/^\/+/, "");
      if (hashOnly.startsWith("#")) {
        window.location.hash = hashOnly.slice(1);
      } else {
        window.location.href = data.redirect;
      }
    },
    onError: (err) => {
      if (err instanceof ApiError) setError(err.message);
      else setError(String(err));
    },
  });

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    claim.mutate(code);
  };

  return (
    <main className="claim-owner">
      <h1>Claim this server</h1>
      <p>
        This k162 server has no owner yet. Enter the 6-character claim code the
        operator gave you to take ownership.
      </p>
      <form onSubmit={onSubmit} className="claim-owner__form">
        <label htmlFor="claim-code">Claim code</label>
        <input
          id="claim-code"
          type="text"
          inputMode="text"
          autoComplete="off"
          spellCheck={false}
          maxLength={6}
          value={code}
          onChange={(e) =>
            setCode(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 6))
          }
          className="claim-owner__code"
        />
        <button
          type="submit"
          disabled={claim.isPending || !/^[A-Z0-9]{6}$/.test(code)}
          className="claim-owner__submit"
        >
          {claim.isPending ? "Submitting…" : "Claim"}
        </button>
      </form>
      {error && (
        <div className="claim-owner__error" role="alert">
          {error}
          <div>
            <a href="/api/auth/login">Restart sign-in</a>
          </div>
        </div>
      )}
    </main>
  );
}
